import { useState, useEffect } from 'react';
import { userApi } from '../api/userApi';

export const useUsers = (businessNetworkID) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const data = await userApi.searchOpenUsers(businessNetworkID);
        setUsers(data.result || []);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (businessNetworkID) {
      fetchUsers();
    }
  }, [businessNetworkID]);

  return { users, loading, error };
};
